module.exports = __webpack_public_path__ + "img/logo.5f4636a5.png";